/* eslint-disable react/forbid-elements */
import { type ReactNode } from 'react';

import styles from './HideIcon.css';

export function HideIcon(): ReactNode {
  return (
    <span className={styles['icon']}>
      <svg fill="none" height="12" viewBox="0 0 16 12" width="16">
        <path
          clipRule="evenodd"
          d="M11.8052 1.21082L13.0161 0H15.8442L3.84418 12H1.01605L3.07923 9.93682C1.10043 8.20098 -6.10352e-05 6 -6.10352e-05 6C-6.10352e-05 6 2.99994 0 7.99994 0C9.44297 0 10.7194 0.499762 11.8052 1.21082ZM5.4442 7.57185L9.57179 3.44426C9.11469 3.16253 8.5763 3 7.99994 3C6.34309 3 4.99994 4.34315 4.99994 6C4.99994 6.57636 5.16247 7.11475 5.4442 7.57185Z"
          fill="currentColor"
          fillRule="evenodd"
        />
        <path
          d="M6.44549 11.8037L14.5082 3.74104C15.4785 4.95718 15.9999 6 15.9999 6C15.9999 6 12.9999 12 7.99994 12C7.45786 12 6.93928 11.9295 6.44549 11.8037Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
}
